export default __webpack_public_path__ + "static/media/Snapchat-1199048726 - Vinay Saini.1243f37d.jpg";